import { useDateFormat } from '@gogame/intl-ts';

export const useStatusCompactDetails = () => {
  const dateFormat = useDateFormat({
    template: 'LLL',
  });

  return (prefix = '', data) =>
    `${prefix} ${dateFormat(data.startedAt)} by ${data.user.email || data.user.name}${data.isExternalApi ? ' via API' : ''}`;
};
